<template>
  <div style="display: flex; flex-direction: row; gap: 10px; width: 100%">
    <TitledNumericalInputField
      inputLabel="Draft"
      iconName="mdi-waves"
      :value="+draft.toFixed(2)"
      :onChange="handleDraftChange"
    />
    <TitledNumericalInputField
      inputLabel="Trim"
      iconName="mdi-slope-downhill"
      :value="+trim.toFixed(3)"
      :onChange="handleTrimChange"
    />
  </div>
</template>


<script>
import { mapState } from "vuex";
import TitledNumericalInputField from "../../../../../k_diagram/components/TitledNumericalInputField.vue";
export default {
  name: "SetFloatingDataComponent",
  components: {
    TitledNumericalInputField,
  },
  data: function () {
    return {};
  },
  computed: {
    ...mapState("weatherRouting/formModule", ["draft", "trim"]),
  },
  methods: {
    handleDraftChange(value) {
      this.$store.commit("weatherRouting/formModule/SET_DRAFT", value, {
        root: true,
      });
    },
    handleTrimChange(value) {
      this.$store.commit("weatherRouting/formModule/SET_TRIM", value, {
        root: true,
      });
    },
  },
};
</script>